import { Instagram, LinkedIn, Telegram } from '@material-ui/icons'
// import { Facebook } from '@mui/icons-material'
import img1 from "../assets/sher.jpg"
import img2 from "../assets/kamron.jpg"
import img3 from "../assets/robiya.jpg"
import img4 from "../assets/firths_kam.jpg"
// import img4 from "../assets/muattar.jpg"
import React from 'react'
import "./Teacher.css"
// import { NavLink } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
const Teacher = () => {
    const { t } = useTranslation();

  return (
    <div className={'Doctors'}>
     <h1>{t("sher.about")}</h1>
    {/*<h4>{t("menuContact1")}</h4> */}
    <div className="card__collection clear-fix">
        <div className="cards cards--three">
                <img src={img1} className="img-responsive" alt="" />
            <h2>{t("navbar3")} </h2>
            <span className="cards--three__rect-1">
                <span className="shadow-1"></span>
                <p>English  teacher </p>
            </span>
            <span className="cards--three__rect-2">
                <span className="shadow-2"></span>
            </span>
            <span className="cards--three__circle"></span>
            <ul className="cards--three__list">
                <li><a href="https://t.me/Shermuhammad8_5"><Telegram /></a></li>
                <li> <a href="https://instagram.com/shermuhammad_8.5?igshid=YmMyMTA2M2Y=https://www.instagram.com/accounts/login/"><Instagram /></a></li>
            </ul>
            
        </div>
        <div className="cards cards--three">
        <img src={img4} className="img-responsive" alt="" />
            <h2> {t("my_teacher.name")}</h2>
            <span className="cards--three__rect-1">
                <span className="shadow-1"></span>
                <p>English  teacher </p>
            </span>
            <span className="cards--three__rect-2">
                <span className="shadow-2"></span>
            </span>
            <span className="cards--three__circle"></span>
            <ul className="cards--three__list">
                <li><a href="https://t.me/absolute_man"><Telegram /></a></li>
                <li> <a href="https://www.instagram.com/kamron_2107/?ysclid=lf41o30plc946861681"><Instagram /></a></li>
            </ul>
        </div>
        <div className="cards cards--three">
        <img src={img3} className="img-responsive" alt="" />
            <h2>{t("robiya.Name")} </h2>
            <span className="cards--three__rect-1">
                <span className="shadow-1"></span>
                <p>Frontend developer</p>
            </span>
            <span className="cards--three__rect-2">
                <span className="shadow-2"></span>
            </span>
            <span className="cards--three__circle"></span>
            <ul className="cards--three__list">
                <li><a href="https://t.me/CoderGirl05"><Telegram /></a></li>
                <li> <a href="https://www.linkedin.com/in/robiya-tukhtayeva-5a1676242/"><LinkedIn /></a></li>
            </ul>
           
        </div>
        <div className="cards cards--three">
        <img src={img2} className="img-responsive" alt="" />
            <h2> {t("mirzakhanov.Name")}</h2>
            <span className="cards--three__rect-1">
                <span className="shadow-1"></span>
                <p>English  teacher </p>
            </span>
            <span className="cards--three__rect-2">
                <span className="shadow-2"></span>
            </span>
            <span className="cards--three__circle"></span>
            <ul className="cards--three__list">
                <li><a href="https://t.me/mirzaxansov"><Telegram /></a></li>
                <li> <a href="https://instagram.com/the_kamron_98?igshid=YmMyMTA2M2Y="><Instagram /></a></li>
            </ul>
        </div>
       
       
        {/* <div className="cards cards--three">
            <img src={img4} className="img-responsive" alt="" />
            <h2>Muattar Nishonova</h2>
            <span className="cards--three__rect-1">
                <span className="shadow-1"></span>
                <p>Matematika</p>
            </span>
            <span className="cards--three__rect-2">
                <span className="shadow-2"></span>
            </span>
            <span className="cards--three__circle"></span>
            <ul className="cards--three__list">
                <li><a href="https://t.me/CoderGirl05"><Telegram /></a></li>

            </ul>
        </div> */}
       
    </div>
</div>
  )
}

export default Teacher